<template lang="pug">
  .b-spec-budget-bar(data-testid="budget-bar" :class="{ over: isOver }")
    span._text(data-testid="budget-bar-text")
      | Плановый бюджет {{ money(budget.plannedTotal) }}
      template(v-if="budget.limit !== null")
        |  при пороге {{ money(budget.limit) }}
        template(v-if="isOver")  (превышение {{ money(budget.excess) }})
        template(v-else)  — укладывается в порог
      | .
      template(v-if="budget.analogCount")
        |  С предложенными аналогами — {{ money(budget.totalWithAnalogs) }}.
    button._toggle(
      v-if="budget.analogCount || analogsOnly"
      type="button"
      data-testid="budget-bar-analogs"
      @click="$emit('toggle-analogs')"
      ) {{ analogsOnly ? 'Показать все позиции' : `Показать позиции с аналогами (${budget.analogCount})` }}
</template>

<script>
import { money } from '@/utils/spec';

/**
 * Итог планового бюджета относительно порога цены и сумма с предложенными аналогами. Все суммы
 * считает сервер (свод спецификации), здесь только показ и переключатель фильтра «позиции с
 * аналогами». Сгенерировано Claude.
 */
export default {
  name: 'SpecBudgetBar',
  props: {
    budget: { type: Object, required: true },
    analogsOnly: Boolean,
  },
  computed: {
    isOver() { return Number(this.budget.excess ?? 0) > 0; },
  },
  methods: { money },
};
</script>

<style scoped lang="scss">
.spec-budget-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  padding: 10px 16px;
  margin-bottom: 14px;
  border-radius: 8px;
  background: var(--color-white);
  font-size: 13px;

  &.over {
    box-shadow: inset 3px 0 0 var(--color-red, #e5484d);
  }

  &__toggle {
    padding: 0;
    border: none;
    background: none;
    color: var(--color-blue);
    font: inherit;
    cursor: pointer;
  }
}
</style>
